import { useMutation, useQueryClient } from "react-query";
import { IpcRest } from "@/hooks/ipc";
import { useAuthUser } from "@/context/auth/AuthContext";
import { querykeys } from "../constants";

/**
 * Marca notificaciones como leídas: `POST /notifications/mark-all-read`.
 *
 * Reemplaza al `ipc_invoke("mark_all_read", { boUrl })` de la era Tauri, que en
 * la web no existe: tiraba `IPC method 'mark_all_read' not supported in web
 * version` y dejaba la campana sin poder marcarse leída — ni una notificación
 * al clickearla, ni todas con el botón (#124).
 *
 * OJO CON LA URL, que es la trampa de este endpoint: **no vive bajo `/api/v1`**.
 * El BFF monta la escritura en `/notifications` y las lecturas en
 * `/api/v1/notifications`, dos nests distintos. Como `IpcRest` tiene de base
 * `VITE_BFF_URL` pelado, la ruta va tal cual — sin prefijo.
 *
 * `userId` viaja porque el body del BFF lo exige, pero **no decide nada**: el
 * handler resuelve el actor del token (`claims.user_id`) y el del body lo
 * ignora.
 *
 * No muestra toasts a propósito: los dos call-sites ya manejan el suyo, y uno
 * acá los duplicaría.
 */
function useMarkNotificationsReadRest() {
  const user = useAuthUser();
  const queryClient = useQueryClient();

  return useMutation(
    async (notificationIds: string[]) =>
      IpcRest.post({
        url: "/notifications/mark-all-read",
        body: { userId: user?.id ?? "", notificationIds },
      }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([querykeys.notifications]);
      },
    }
  );
}

export default useMarkNotificationsReadRest;
